import request from '../httpClient';
// tslint:disable
export const getListUsers = (params: any) => request.get('/users', params);
export const getUser = (userId: number) => request.get(`/users/${userId}`);
export const updateUser = (userId: number, data: any) =>
  request.put(`/users/${userId}`, data);



// WEBPACK FOOTER //
// ./src/services/api/usersApi.ts